import { useTranslation } from 'i18n';
import { Typography } from 'ui';

import { guideImages } from '../../data';
import { GuideImage } from '../GuideImage/GuideImage';
import { GuideTitle } from '../GuideTitle/GuideTitle';

export const PartOne = ({ obfuscateAi }: { obfuscateAi: boolean }) => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideTitle obfuscateAi={obfuscateAi} />
      <GuideImage src={guideImages.baleOneMetre} alt={t('backlog.helpGuides.aiBale.partOne.imageAlt')} />
      <Typography
        sx={{
          textAlign: 'start',
        }}
      >
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiBale.partOne.boldText')}&nbsp;
        </Typography>
        {t('backlog.helpGuides.aiBale.partOne.trailingText')}
      </Typography>
    </>
  );
};
